import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Typography, Stack } from "@mui/material";
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineDot,
  TimelineConnector,
  TimelineContent,
} from "@mui/lab";
import { Button } from "@mui/material";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import { useLocation, useNavigate } from "react-router-dom";
import { getActivityDetails } from "../../../configs/WebService";
import {
  setSelectedActivity,
  setSelectedEvent,
} from "../redux/eventOrganiserSlice";
import { apiKeyHeader } from "../../../configs/ApiKeys";
import { GetActivityDetailsThunk } from "../redux/eventOrganiserThunks";
import EventCostSummary from "./EventCostSummary";
import Popup from "../Popup";

const BulletinFromSelectedEvent = () => {
  const selectedEvent = useSelector(
    (state) => state.eventOrganiser.selectedEvent
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [expandedItems, setExpandedItems] = useState({});
  const [showPopup, setShowPopup] = useState(false);

  const toggleExpand = (index) => {
    setExpandedItems((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  if (!selectedEvent || !selectedEvent.activities) {
    const { event } = location.state;
    if (event) {
      return dispatch(setSelectedEvent(event));
    } else {
      return <Typography>No Event or Activities Found</Typography>;
    }
  }

  const parseOptions = (optionsStr) => {
    try {
      const options = JSON.parse(optionsStr);
      return Object.entries(options)
        .filter(([_, value]) => value === 1)
        .map(([key]) => key.replace("is", ""))
        .join(", ");
    } catch {
      return "";
    }
  };

  const parseAssignedUsers = (usersStr) => {
    try {
      const users = JSON.parse(usersStr);
      return users.map((user) => user.name).join(", ");
    } catch {
      return "";
    }
  };

  const handleActivityDetails = async (activityId) => {
    await dispatch(GetActivityDetailsThunk({ activityId }));
    navigate("/activity-details", {
      state: { activityId },
    });
  };

  // const getTotalCost = () => {
  //   let total = 0;
  //   selectedEvent.activities.forEach((activity) => {
  //     activity.cost_sheets?.forEach((sheet) => {
  //       if (sheet.cst_status === "1") {
  //         sheet.items?.forEach((item) => {
  //           total += parseFloat(item.price || 0);
  //         });
  //       }
  //     });
  //   });
  //   return total;
  // };
  const getTotalCost = () => {
    let total = 0;

    selectedEvent.activities.forEach((activity) => {
      (activity.cost_sheets || []).forEach((sheet) => {
        if (sheet.cst_status === "1") {
          (sheet.items || []).forEach((item) => {
            if (item.parentcode === "cmkey_boq_bom") {
              total +=
                parseFloat(item.total_cost || 0) * parseFloat(item.nos || 1);
            }
          });
        }
      });
    });

    console.log("Filtered Total (cmkey_boq_bom):", total);
    return total;
  };

  return (
    <div className="main_container">
      <button
        style={{
          border: "none",
          padding: "10px",
          backgroundColor: "rgba(25,118,210,255)",
          color: "white",
          borderRadius: "10px",
          marginBottom: "1%",
        }}
        onClick={() => window.history.back()}
      >
        Go Back
      </button>
      <div className="right_col" role="main" style={{ overflow: "auto" }}>
        <Box sx={{ px: 2, pt: 2 }}>
          {/* <Typography variant="h5" color="primary" gutterBottom>
            Event: {selectedEvent.name}
          </Typography>
          <EventCostSummary /> */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center", //
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: 2,
              mb: 2,
            }}
          >
            <Typography variant="h5" color="primary" gutterBottom>
              Event: {selectedEvent.name}
            </Typography>
            <Typography variant="h6" color="secondary">
              Total Summary: ₹{getTotalCost()}
            </Typography>
            <Button variant="contained" onClick={() => setShowPopup(true)}>
              View Summary
            </Button>
          </Box>
          {showPopup && (
            <Popup
              title={"Summary Of Cost Sheet "}
              minHeight="400px"
              maxWidth="800px"
              onClose={() => setShowPopup(false)}
            >
              <Box
                sx={{
                  width: "90vw",
                  maxWidth: 900,
                  maxHeight: "80vh",
                  overflowY: "auto",
                  p: 2,
                  bgcolor: "background.paper",
                  borderRadius: 1,
                }}
              >
                <EventCostSummary />
              </Box>
            </Popup>
          )}
          <Timeline
            position="right"
            sx={{
              [`& .MuiTimelineItem-root::before`]: { flex: 0, padding: 0 },
            }}
          >
            <Box
              display="flex"
              flexWrap="wrap"
              gap={4}
              rowGap={6}
              style={{ marginTop: "20px" }}
            >
              {selectedEvent.activities?.map((activity, index) => (
                <Box
                  key={index}
                  width={{ xs: "100%", sm: "48%", md: "23%" }} // Adjust widths for responsiveness
                  minWidth={250} // Optional: to prevent shrinking too much
                >
                  <TimelineItem>
                    <TimelineSeparator>
                      <TimelineDot color="primary">
                        <ArticleOutlinedIcon />
                      </TimelineDot>
                    </TimelineSeparator>

                    <TimelineContent>
                      <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Typography variant="subtitle1" fontWeight="bold">
                          {activity.activity_name || activity.name || "Unnamed Activity"}
                        </Typography>
                      </Stack>

                      <Typography variant="body2" sx={{ mt: 1 }}>
                        <strong>Description:</strong> {activity.activity_desc || activity.description || "—"}
                      </Typography>

                      <Typography variant="body2" sx={{ mt: 1 }}>
                        <strong>Assigned Users:</strong>{" "}
                        {parseAssignedUsers(activity.assigned_users)}
                      </Typography>

                      <Button
                        variant="outlined"
                        size="small"
                        sx={{ mt: 1 }}
                        onClick={() => {
                          console.log("Activity clicked:", activity);
                          handleActivityDetails(activity.id);
                        }}
                      >
                        View Details
                      </Button>
                    </TimelineContent>
                  </TimelineItem>
                </Box>
              ))}
            </Box>
          </Timeline>
          {/* old code */}
          {/* <Timeline
            position="right"
            sx={{
              [`& .MuiTimelineItem-root::before`]: { flex: 0, padding: 0 },
            }}
          >
            {selectedEvent.activities?.map((activity, index) => (
              <TimelineItem key={index}>
                <TimelineSeparator>
                  <TimelineDot color="primary">
                    <ArticleOutlinedIcon />
                  </TimelineDot>
                  <TimelineConnector />
                </TimelineSeparator>

                <TimelineContent>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Typography variant="subtitle1" fontWeight="bold">
                      {activity.name}
                    </Typography>
                    {activity.status === 1 && (
                      <Typography variant="caption" sx={{ color: "green" }}>
                        Active
                      </Typography>
                    )}
                  </Stack>

                  <Typography variant="body2" sx={{ mt: 1 }}>
                    <strong>Description:</strong> {activity.description}
                  </Typography>

                  <Typography variant="body2" sx={{ mt: 1 }}>
                    <strong>Options:</strong> {parseOptions(activity.options)}
                  </Typography>

                  <Typography variant="body2" sx={{ mt: 1 }}>
                    <strong>Assigned Users:</strong>{" "}
                    {parseAssignedUsers(activity.assigned_users)}
                  </Typography>
                  <Button
                    variant="outlined"
                    size="small"
                    sx={{ mt: 1 }}
                    onClick={() => {
                      dispatch(setSelectedActivity(activity));
                      navigate("/activity-details");
                    }}
                  >
                    View Details
                  </Button>
                </TimelineContent>
              </TimelineItem>
            ))}
          </Timeline> */}
        </Box>
      </div>
      {/* <Footer /> */}
    </div>
  );
};

export default BulletinFromSelectedEvent;
